<div class="fusion-text">
  <h3
    style="text-align: center; --fontSize: 28; line-height: 1.45"
    data-fontsize="28"
    data-lineheight="40.6px"
    class="fusion-responsive-typography-calculated"
  >
    {{ desc.value }}
  </h3>
</div>
<div class="fusion-text">
  <p style="text-align: center">
    {{ desc.description }}
  </p>
</div>
<div class="fusion-sep-clear"></div>
<div>
  <ul
    class="fusion-checklist fusion-checklist-16"
    style="font-size: 16px; line-height: 27.2px"
  >
    <div [formGroup]="form">
      <li class="fusion-li-item">
        <input
          id="MRCEA"
          type="checkbox"
          class="yellowBorderedCheckbox"
          (change)="score($event)"
          formControlName="MRCEA"
        />
        <label
          for="MRCEA"
          class="fusion-text"
          style="font-size: 20px; color: #666666"
          ><span></span>{{ list[0].description }}</label
        >
      </li>

      <li class="fusion-li-item">
        <input
          id="MRTEA"
          type="checkbox"
          class="yellowBorderedCheckbox"
          (change)="score($event)"
          formControlName="MRTEA"
        />
        <label
          for="MRTEA"
          class="fusion-text"
          style="font-size: 20px; color: #666666"
          ><span></span>{{ list[1].description }}</label
        >
      </li>

      <li class="fusion-li-item">
        <input
          id="MAPCOV"
          type="checkbox"
          class="yellowBorderedCheckbox"
          (change)="score($event)"
          formControlName="MAPCOV"
        />
        <label
          for="MAPCOV"
          class="fusion-text"
          style="font-size: 20px; color: #666666"
          ><span></span>{{ list[2].description }}</label
        >
      </li>

      <li class="fusion-li-item">
        <input
          id="MRLPL"
          type="checkbox"
          class="yellowBorderedCheckbox"
          (change)="score($event)"
          formControlName="MRLPL"
        />
        <label
          for="MRLPL"
          class="fusion-text"
          style="font-size: 20px; color: #666666"
          ><span></span>{{ list[3].description }}</label
        >
      </li>

      <li class="fusion-li-item">
        <input
          id="MRARS"
          type="checkbox"
          class="yellowBorderedCheckbox"
          (change)="score($event)"
          formControlName="MRARS"
        />
        <label
          for="MRARS"
          class="fusion-text"
          style="font-size: 20px; color: #666666"
          ><span></span>{{ list[4].description }}</label
        >
      </li>
    </div>
    <div class="fusion-button-wrapper fusion-alignright">
      <style type="text/css">
        .fusion-button.button-1 {
          border-radius: 50px;
        }
      </style>
      <a
        class="
          fusion-button
          button-flat button-small button-default button-1
          fusion-button-span-no fusion-button-default-type
        "
        style="pointer-events: none"
        ><span class="fusion-button-text">PUNTEGGIO: {{ scoreNumber }}</span></a
      >
    </div>

    <!-- <li class="fusion-li-item" *ngFor="let i of this.list">
      <input
        id="{{ i.code }}"
        type="checkbox"
        class="yellowBorderedCheckbox"
        value="{{ i.code }}"
        (change)="score($event)"
        (ngModel)="getString(i)"
      />
      <label
        for="{{ i.code }}"
        class="fusion-text"
        style="font-size: 20px; color: #666666"
        ><span></span>{{ i.description }}</label
      >
    </li> -->

    <!-- <li class="fusion-li-item" formGroupName="rigore">
      <input
        id="MRCEA"
        type="checkbox"
        class="yellowBorderedCheckbox"
        (click)="score($event)"
        formControlName="MCREA"
      />
      <label
        for="MRCEA"
        class="fusion-text"
        style="font-size: 20px; color: #666666"
        ><span></span></label
      >
      <input
        id="MRTEA"
        type="checkbox"
        class="yellowBorderedCheckbox"
        (click)="score($event)"
        formControlName="MRTEA"
      />
      <label
        for="MRTEA"
        class="fusion-text"
        style="font-size: 20px; color: #666666"
        ><span></span></label
      >
    </li> -->

    <!-- <li
      class="fusion-li-item"
      *ngFor="let j of this.form.controls.rigore.controls; let i; of: this.list"
    >
      <input
        id="{{ i.code }}"
        formControl="{{ j }}"
        type="checkbox"
        class="yellowBorderedCheckbox"
        (change)="score($event)"
      />
      <label
        for="{{ i.code }}"
        class="fusion-text"
        style="font-size: 20px; color: #666666"
        ><span></span>{{ i.description }}</label
      >
    </li> -->
  </ul>
</div>

<div class="fusion-sep-clear"></div>
<div
  class="fusion-separator fusion-full-width-sep sep-none"
  style="margin-left: auto; margin-right: auto; margin-top: 50px"
></div>

<!--
  SCORE


  <div class="fusion-button-wrapper fusion-alignright">
  <style type="text/css">
    .fusion-button.button-1 {
      border-radius: 50px;
    }
  </style>
  <a
    class="
      fusion-button
      button-flat button-small button-default button-1
      fusion-button-span-no fusion-button-default-type
    "
    style="pointer-events: none"
    ><span class="fusion-button-text">PUNTEGGIO: {{ scoreNumber }}</span></a
  >
</div> -->
